import { render } from "./ContactComponent.vue?vue&type=template&id=afffb392&scoped=true"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=afffb392&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ahmed.shaker.KORABIA\\Desktop\\hesabtech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afffb392"]])

export default __exports__